import React from 'react';
import type { FC } from 'react';
import { Customer, Reservation } from '@/services/api/entities';
import { getPropertyName } from '@/services/utils/strings';
import SidebarReservationCard from './SidebarReservationCard';
import SidebarGroupName from './SidebarGroupName';
import SidebarCustomerCard from './SidebarCustomerCard';
import SidebarDivider from './SidebarDivider';
import SidebarFilterNotice from './SidebarFilterNotice';

interface Props {
  readonly customers: Customer[];
  readonly reservations: Reservation[];
}

const SidebarSearchData: FC<Props> = ({ customers, reservations }) => {
  const limit = 5 as const;
  const hasCustomers = customers.length > 0;
  const hasReservations = reservations.length > 0;
  const hasDivider = hasCustomers && hasReservations;
  const hiddenCustomers = customers.length - limit;
  const filteredCustomers = customers.slice(0, limit);

  return (
    <>
      <SidebarGroupName show={hasReservations}>
        RESERVATIONS
      </SidebarGroupName>

      { reservations.map(({ id, customer, startDate, endDate, property }) => {
        const propertyName = getPropertyName(property);

        return (
          <SidebarReservationCard
            key={id}
            reservationId={id}
            customerFirstName={customer?.firstName}
            customerLastName={customer?.lastName}
            startDate={startDate}
            endDate={endDate}
            propertyName={propertyName}
          />
        );
      }) }

      <SidebarDivider show={hasDivider} />

      <SidebarGroupName show={hasCustomers}>
        GUESTS
      </SidebarGroupName>

      { filteredCustomers.map(({ id, firstName, lastName, email, phone: phoneNumber }) => {
        return (
          <SidebarCustomerCard
            key={id}
            customerId={id}
            firstName={firstName}
            lastName={lastName}
            email={email}
            phoneNumber={phoneNumber}
          />
        );
      }) }

      <SidebarFilterNotice hiddenCount={hiddenCustomers} />
    </>
  );
};

export default SidebarSearchData;
